import { render, staticRenderFns } from "./AudioReviewForm.vue?vue&type=template&id=2e997f6f"
import script from "./AudioReviewForm.vue?vue&type=script&lang=js"
export * from "./AudioReviewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports